<template>
  <span class="assignee-chip">
    <template v-if="kind === 'person'">
      <support-avatar :src="appeal.assignee.avatar" :name="appeal.assignee.name" :size="24" />
      {{ appeal.assignee.name }}
    </template>
    <!-- Идея: специалиста нет, её читает команда разработки -->
    <template v-else-if="kind === 'team'">
      <support-avatar
        :src="teamAvatar"
        :srcset="`${teamAvatar2x} 2x`"
        name="FAKT"
        :size="24"
      />
      Команда FAKT
    </template>
    <!-- Никто ещё не взял: серый «?» и «изучаем» (Q29) -->
    <template v-else>
      <span class="assignee-chip__unknown">?</span>
      <span class="assignee-chip__muted">изучаем</span>
    </template>
  </span>
</template>

<script>
  import SupportAvatar from './SupportAvatar.vue'
  import { assigneeKind } from './status'
  import teamAvatar from '@/assets/support/avatar-fakt-support.png'
  import teamAvatar2x from '@/assets/support/avatar-fakt-support@2x.png'

  export default {
    name: 'AssigneeChip',
    components: { SupportAvatar },
    props: {
      appeal: { type: Object, required: true },
    },
    data () {
      return { teamAvatar, teamAvatar2x }
    },
    computed: {
      kind () {
        return assigneeKind(this.appeal)
      },
    },
  }
</script>

<style scoped lang="less">
@import './tokens.less';

.assignee-chip {
  display: inline-flex;
  flex-shrink: 0;
  gap: 8px;
  align-items: center;
  height: 30px;
  padding: 3px 12px 3px 3px;
  border-radius: 100px;
  font-size: 12px;
  white-space: nowrap;
  color: @fakt-text;
  background: @fakt-surface;
}

.assignee-chip__unknown {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 500;
  color: @fakt-text-3;
  background: @fakt-white;
}

.assignee-chip__muted {
  color: @fakt-text-2;
}
</style>
